var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React from 'react';
import dayjs from 'dayjs';
// store
import useDashboardStore from '@/stores/Dashboard';
import useAccountStore from '@/stores/account';
// components
import { PerformanceSummary } from '@/components/PerformanceSummary';
// styles
import styles from './PerformanceSummary.module.scss';
// defs
import { AdvertiserDimensions } from '@local/typedefs/dist/protos/campaign/AdvertiserMetrics';
// includes
import { getMetricsApi } from '@/includes/api/metrics';
const PerformanceSummaryWrapper = () => {
    const { campaignsPerformance, activeCampaignIds, setCampaignsPerformanceData, setSelectedRange, } = useDashboardStore((state) => ({
        activeCampaignIds: state.activeCampaigns.map((campaign) => campaign.id),
        setSelectedRange: state.setSelectedRange,
        campaignsPerformance: state.campaignsPerformance,
        setCampaignsPerformanceData: state.setCampaignsPerformanceData,
    }));
    const getCurrentAccountId = useAccountStore((state) => state.getCurrentAccountId);
    const fetchMetrics = (startDate, endDate, rangeType) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const accountId = yield getCurrentAccountId();
            const performanceMetricsResult = yield getMetricsApi({
                accountId,
                dimensions: [AdvertiserDimensions.DIMENSION_DAY],
                campaignIds: activeCampaignIds,
                interval: {
                    startTime: dayjs(startDate).toString(),
                    endTime: dayjs(endDate).toString(),
                },
            });
            if (performanceMetricsResult) {
                setCampaignsPerformanceData((_a = performanceMetricsResult.metrics) === null || _a === void 0 ? void 0 : _a.metricsOnDimension);
                setSelectedRange({
                    type: rangeType,
                    range: {
                        startTime: startDate.toISOString(),
                        endTime: endDate.toISOString(),
                    },
                });
            }
        }
        catch (err) {
            if (__DEV__) {
                console.log(err);
            }
        }
    });
    // do not show performance summary tile if there is no data
    if (!Array.isArray(campaignsPerformance.data) ||
        (Array.isArray(campaignsPerformance.data) &&
            campaignsPerformance.data.length === 0)) {
        return null;
    }
    return (React.createElement("div", { className: styles.wrapper },
        React.createElement(PerformanceSummary, { performanceData: campaignsPerformance, campaignIds: activeCampaignIds, className: styles.table, fetchMetrics: fetchMetrics })));
};
export default PerformanceSummaryWrapper;
